import { abortableFetch, useFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export const uploadMPT = (body: FormData) => {
  return abortableFetch(EvidenceApiUrl.MPT, {
    method: 'POST',
    body,
  });
};

export const useLastSync = () => {
  return useFetch<Date>(`${EvidenceApiUrl.MPT}/sync`, {
    method: 'GET',
    cacheResponse: false,
  });
};

export enum MptFormMode {
  DEFAULT = 'DEFAULT',
  LOADING = 'LOADING',
  EDITING = 'EDITING',
}
